import type { Icon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'

import { kuniriIconWeight } from '@/lib/icons'

interface FormSectionProps {
  title: string
  icon: Icon
  children: ReactNode
}

export function FormSection({ title, icon: SectionIcon, children }: FormSectionProps) {
  return (
    <section className="activity-section">
      <div className="activity-section__header">
        <span className="activity-section__icon">
          <SectionIcon
            size={19}
            weight={kuniriIconWeight}
            aria-hidden="true"
          />
        </span>
        <h2 className="activity-section__title">{title}</h2>
      </div>
      <div className="activity-section__body">{children}</div>
    </section>
  )
}
